import PropTypes from 'prop-types';
import { Alert, Button } from '@mui/material';
import compareVersions from '../../../services/firmware/compareVersions';

export default function UpdateAvailableBanner({ currentVersion, latestVersion, onUpdate }) {
  const behind = currentVersion && latestVersion && compareVersions(currentVersion, latestVersion) < 0;
  if (!behind) return null;
  return (
    <Alert severity="info" sx={{ mb: 2 }} action={<Button color="inherit" size="small" onClick={onUpdate}>Update</Button>}>
      Update available for your sensor ({currentVersion} &rarr; {latestVersion}).
    </Alert>
  );
}

UpdateAvailableBanner.propTypes = {
  currentVersion: PropTypes.string,
  latestVersion: PropTypes.string,
  onUpdate: PropTypes.func.isRequired,
};
